<template>
  <div class="modal-popup">
    <div class="modal fade" id="cancelBookingPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mb-2 ml-3">Rezervasyon İptal</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
            <div class="modal-body">
              <div class="contact-form-action">
                <div class="col-lg-12">
                  <div class="card-item p-3">
                    <div class="row" >
                      <div class="contact-form-action col-sm-6">
                        <base-edit-input
                            v-model="creditCardRefundAmount"
                            :rules="'min_value:0'"
                            :type="'number'"
                            :label="'Kredi Kartına İade Miktarı'">
                        </base-edit-input>
                        <base-edit-input
                            v-model="couponRefundAmount"
                            :rules="'min_value:0'"
                            :type="'number'"
                            :label="'Kupon İade Miktarı'">
                        </base-edit-input>
                        <base-edit-input
                            v-model="cashRefundAmount"
                            :rules="'min_value:0'"
                            :type="'number'"
                            :label="'Nakit İade Miktarı'">
                        </base-edit-input>
                      </div>
                    </div>
                    <div class="col-12">
                      <div v-if="!checkPriceAmountsForCancelation" class="form-group" :class="'error'">
                        <h1 class="error-text">Farklı ödeme kanallarına yapılan iade tutarları toplam rezervasyon tutarından fazla olamaz.</h1>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="contact-form-action ml-4">
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Geri</button>
            <button :class="!checkPriceAmountsForCancelation ? 'disabled':null" @click="cancelBooking" type="button" class="theme-btn theme-btn-small" style="background-color: RED;color: WHITE;"> Rezervasyonu İptal Et</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseEditInput from "../base/BaseEditInput";
import messagePopupManager from "../../util/messagePopupManager";
export default {
  name: "CancelBookingPopup",
  components: {BaseEditInput},
  data:function (){
    return{
      cashRefundAmount: 0,
      couponRefundAmount: 0,
      creditCardRefundAmount: 0
    }
  },
  computed : {
    booking:{
      get(){
        return this.$store.getters.getBooking;
      }
    },
    checkBookingPayments:{
      get(){
        return this.$store.getters.getCheckBookingPayments
      }
    },
    checkPriceAmountsForCancelation(){
      let valid = false;
      const total = this.checkBookingPayments.paidAmount;
      const returnTotal = parseInt(this.cashRefundAmount === "" ? '0':this.cashRefundAmount)
          + parseInt(this.couponRefundAmount === "" ? '0':this.couponRefundAmount)
          + parseInt(this.creditCardRefundAmount === "" ? '0': this.creditCardRefundAmount);
      if(returnTotal <=  total){
        valid = true;
      }else{
        valid = false;
      }
      console.log("total")
      console.log(total)
      console.log("returnTotal")
      console.log(returnTotal)
      return valid;
    }
  },
  methods:{
    cancelBooking(){
      if(!this.checkPriceAmountsForCancelation) return
      let cancelBookingRequest = {};
      cancelBookingRequest.bookingId = this.booking.id;
      cancelBookingRequest.cashRefundAmount = this.cashRefundAmount;
      cancelBookingRequest.couponRefundAmount = this.couponRefundAmount;
      cancelBookingRequest.creditCardRefundAmount = this.creditCardRefundAmount;
      this.$store.dispatch("postCancel", cancelBookingRequest).then(response => {
        messagePopupManager.showSuccess()
        $("#cancelBookingPopup").modal("hide");
      })
    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  },
}
</script>

<style scoped>
.disabled{
  background-color: gray !important;
  pointer-events: none;
}
</style>